<template>
  <div id="list-demo">
    <div class="ml-4">
        <button v-on:click="test" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Cancel
        </button>
        <button v-on:click="savelistview" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Save
        </button>

          <button v-on:click="saveDeploylistview" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Save and Deploy
        </button>
        <DxSelectBox         
        :items="relatedModules"
         width=200
         @value-changed="onValueChanged"
        />
    </div>  
    <div class="widget-container">

      <div class="bg-gray-50 border-gray-300 mr-4">  
          <span class="list-title">Available fields</span>
      <DxList
        :data-source="list2"
        :repaint-changes-only="true" 
        key-expr="name"
        display-expr="label.text"
        >
        
        <DxItemDragging
          data="list2"          
          :allow-reordering="true"
          :on-drag-start="onDragStart"
          :on-add="onAdd"
          :on-remove="onRemove"
          group="tasks"
        />     
        
      </DxList>
      </div>
      <div class="bg-gray-50 ">
          <span class="list-title">List View</span>
      <DxList
        :data-source="list1"
        :repaint-changes-only="true"
        key-expr="name"
        display-expr="label.text"
      >
        <DxItemDragging
          data="list1"
          :allow-reordering="true"
          :on-drag-start="onDragStart"
          :on-add="onAdd"
          :on-remove="onRemove"
          group="tasks"
        />
      </DxList>
      </div>
        
    </div>
    
  </div>
</template>

<script>

import DxList, { DxItemDragging } from 'devextreme-vue/list';
import { confirm, alert } from 'devextreme/ui/dialog';
import {getLineItemFieldList,getFieldsList,getLayout,setLayout, getRelate,objSize,setDeployLayout} from '../../base.js';
import { DxSelectBox } from 'devextreme-vue/select-box'

export default {
    props:{
        modulekey:String,
        studio:Boolean,
        route_slug: String,
    },
    components: {
        DxList,
        DxItemDragging,
        DxSelectBox
    },
    data() {
            return {
                fieldList:[],
                list1: [],
                list2: [],
                lineItemLists: [],
                relatedModules:[],
                selectedRelate:""
                };
        },
    methods:{
             getRelateModule()
             {
                //console.log("LINE RELATED MODULE");
                getRelate(this.modulekey,this.studio,this.route_slug).then(response => {     
                    //console.log("RESPONSE AA GYA");              
                    //this.relatedModules = response.data;
                    //console.log("LINE ITEM MODULE"+response.data);

                }).catch(error => {
                   console.log("error");
                });
             },
             //
             getLineItemFields()
             {
                //pass modulekey and studio 
                getLineItemFieldList(this.modulekey,this.studio).then(response => {
                    
                    //let fldnm = response.data;
                    //console.log(response.data);
                    
                    //let rmodName = fldnm.split("_LineItem");                    
                    this.relatedModules =response.data;

                }).catch(error => {
                   console.log("error in line item field list");
                });
             },

             onValueChanged(e) {


                let fldnm = e.value;
                let rmodName = fldnm.split("_LineItem");

                this.selectedRelate = rmodName[0]; 
                

                this.getRelateFieldList();
                //console.log("kjhh");   
                
                
                //console.log(e.value);
            },         
            savelistview()
            {
                let data = {};
                data[this.selectedRelate+"_LineItem"] =this.list1;
                let model=JSON.stringify(data, null, 2);
                this.errors = {};    
                               
                setLayout(this.modulekey,"lineitemview",this.studio,model,this.route_slug).then(response => {
                    //console.log('get'+JSON.stringify(response.data));
                }).catch(error => {
                    if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                    }
                });
            },


              saveDeploylistview()
            {
                let data = {};
                data[this.selectedRelate+"_LineItem"] =this.list1;
                //console.log("SENDING LINE ITEM DATA",data);
                let model=JSON.stringify(data, null, 2);
                this.errors = {};    
                               
                setDeployLayout(this.modulekey,"lineitemview",this.studio,model,this.route_slug).then(response => {
                    //console.log('get'+JSON.stringify(response.data));
                }).catch(error => {
                    if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                    }
                });
            },





            getRelateFieldList()
            {
                this.errors = {};                    
                getFieldsList(this.selectedRelate,this.studio,false,this.route_slug).then(response => {
                

                    this.list2 = Object.values(response.data);
                    this.fieldList = Object.values(response.data);
                  const selectedRelateLineItemKey = this.selectedRelate + "_LineItem";

                    if(objSize(this.lineItemLists) > 0  )
                    {   
                        //console.log("getRelateFieldListlineItemLists ",this.lineItemLists);
                        //console.log("getRelateField SLECTED RELATED ",this.selectedRelate);
                        if(this.lineItemLists[selectedRelateLineItemKey]){

                        this.list1 = this.lineItemLists[selectedRelateLineItemKey]; 
                        this.list2 = this.list2.filter(item => !this.list1.find(field => item.dataField === field.dataField));
                        this.list1 = this.list1.filter(item => this.fieldList.find(field => item.dataField === field.dataField));
                        }
                       
                       
                    }
                                     
                }).catch(error => {
                    console.log(error);
                    /* if (error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                    } */
                });
            },
            onDragStart(e) {
                e.itemData = this[e.fromData][e.fromIndex];
            },
            onAdd(e) {
                const data = [...this[e.toData]];
                console.log("ON ADD DATA",data);
                data.splice(e.toIndex, 0, e.itemData);
                this[e.toData] = data;
            },
            onRemove(e) {
                const data = [...this[e.fromData]];
                data.splice(e.fromIndex, 1);
                this[e.fromData] = data;
            }    
        },
        created: function () { 
            /* this.errors = {};                     
            getFieldsList(this.modulekey,this.studio,false).then(response => {
                this.list2 = Object.values(response.data);
                this.fieldList = Object.values(response.data);
                //console.log(this.list2);                  
            }).catch(error => {
                //console.log(error);
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            }); */
        
            this.getLineItemFields();
            //get the editview layout
            this.getRelateModule();
             getLayout(this.modulekey,"lineitemview",this.studio,this.route_slug).then(response => {
                

                
                this.lineItemLists=response.data;
                
                console.log("getLayout LineITEM",this.lineItemLists);
                //this.list1 = response.data;
                //this.list2 = this.list2.filter(item => !this.list1.find(field => item.dataField === field.dataField));
                //this.list1 = this.list1.filter(item => this.fieldList.find(field => item.dataField === field.dataField));

            }).catch(error => {
                /* if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
                } */
            });

        
        },
        mounted()
        {
            
        }
}
</script>

<style>
.widget-container {
    display: flex;
    width: 50%;
    margin: 20px;
}

.widget-container > * {
    height: 400px;
    width: 50%;
    padding: 10px;
}

.dx-scrollview-content {
    min-height: 380px;
}
.list-title {
    font-size: 16px;
    padding: 10px;
    padding-left: 30px;   
    font-weight: bold;
    cursor: pointer;
}

</style>